/*
 * @Description: 退票改签原因卡片
 */
 /*
 退票和改签的原因都是一个页面
 */
<template minapp="mpx" xlang="wxml">
  <view class="es-refund-card" wx:if="{{content!=null && content.length > 0}}">
    <view class="es-refund-card__header">
      <view class="es-refund-card__title">{{title}}  </view>
      <view class="es-refund-card__title-tips">{{titleTips}}  </view>
    </view>
    <view class="es-refund-card__divider"></view>
    <es-radio-group
          wx:model="{{selected}}"
          direction='column'
          bind:input="onClick"
      >
        <view
            wx:for="{{content}}"
            wx:key="index"
        >
          <es-radio
              label-position='left'
              label-class="label-class"
              name='{{item}}'
              useIconSlot
              icon-style="{{{borderRadius: '6px'}}}" 
              iconSize="{{18}}"
        >
         <es-icon
          slot="icon"
          size="10"
          name="check-filled"
          wx:style="{{checkboxIconStyle}}"
        />
        <view class="es-refund-card__content in">  
          <view class="es-refund-card__item">
            {{item}} 
          </view>
          <view wx:if="{{item == '其他'}}" class="es-refund-card__title-tips">{{reasonTips}}</view>
        </view>
        </es-radio>
      
      </view>
     </es-radio-group>
    <textarea wx:if="{{selected=='其他'}}"
          maxlength="{{100}}"
          class="es-refund-card__input"
          placeholder="可填写原因说明，最多填写100字，超出不可继续填写"
          bindinput="onClick($event)"
          wx:model="{{inputdata}}"
        />
   
  
  </view>
  
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      title: String,
      content: {
        type: Array,
        value: []
      },
      titleTips: String,
      reasonTips: String
    },
    data: {
      selected: '',
      inputdata: '',
      checkboxIconStyle: {
        width: '18px'
      }
    },
    methods: {
      onClick(event) {
        this.inputdata = ''
        this.triggerEvent('change', event)
      }
    }
  })
</script>

<style lang='stylus' src="./style.styl"  scoped></style>
<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'es-radio': '@didi/es-mpx-ui/lib/radio/index',
      'es-radio-group': '@didi/es-mpx-ui/lib/radio-group/index',
      'es-checkbox': '@/es-mpx-ui/lib/checkbox'
    }
  }
</script>